export default {
  API: {
    SEARCH_SEARCH: '/api/search',
    SEARCH_PROPOSITION: '/api/search/proposition',
    SEARCH_COVERAGES: '/api/search/coverage'
  }
};
